import { Component, OnInit } from '@angular/core';
import { environment } from '@env/environment';
import { IframeComponent } from 'app/shared/iframe/iframe.component';
@Component({
  selector: 'app-superset',
  templateUrl: './superset.component.html',
  styleUrls: ['./superset.component.scss'],
  imports: [IframeComponent],
  standalone: true
})
export class SupersetComponent implements OnInit {
  url: string;

  ngOnInit(): void {
    this.url = environment.supersetUrl;
  }
}
